import React from 'react';
import { MonthConvert, MonthConvert_year } from './utility'
const trimstre = {
  "first": 'Premier trimestre',
  'second': 'Deuxième trimestre',
  'third': 'Troisième trimestre'
}
function PeriodTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >Cycle menstruel</th>
            <th >Jours d'ovulation les plus probables</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert(item.startDatePeriods)} - {MonthConvert(item.endDatePeriods)}</td>
              <td>{MonthConvert(item.ovulationWindowStart)} - {MonthConvert(item.ovulationWindowEnd)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function OvulationTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr className='highlightedOk'>
            <th className="">État</th>
            <th className="">Résultats</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Date d'ovulation la plus probable</td>
            <td>{MonthConvert_year(result.mostProbableOvulationDate)}</td>
          </tr>
          <tr>
            <td>Fenêtre sexuelle pour la conception</td>
            <td>{MonthConvert_year(result.intercourseWindowForPregnancy)}</td>
          </tr>
          <tr>
            <td>Test de grossesse</td>
            <td>{MonthConvert_year(result.pregnancyTest)}</td>
          </tr>
          <tr>
            <td>Début des prochaines menstruations</td>
            <td>{MonthConvert_year(result.nextPeriodStart)}</td>
          </tr>
          <tr>
            <td>Date d'accouchement si vous êtes enceinte</td>
            <td>{MonthConvert_year(result.dueDateIfPregnant)}</td>
          </tr>
        </tbody>
      </table>
    )
  }
}
function OvulationTableV2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result.importantDatesForNextSixMonths
    return (
      <table >
        <thead>
          <tr>
            <th >Début du cycle menstruel</th>
            <th >Fenêtre d'ovulation</th>
            <th >Date d'accouchement prévue</th>
          </tr>
        </thead>
        <tbody>
          {response.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.ovulationWindowStart)} - {MonthConvert_year(item.ovulationWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDateIfPregnant)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function ConceptionTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <table >
        <thead>
          <tr>
            <th >Début du cycle menstruel</th>
            <th >Fenêtre de conception</th>
            <th >Date d'accouchement prévue</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="" key={index}>
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.conceptionWindowStart)} - {MonthConvert_year(item.conceptionWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
function OvulationTableFull({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <div className="col">
        <p>Dates importantes pour ce cycle :</p>
        <OvulationTable result={result}></OvulationTable>
        <br></br>
        <br></br>
        <p>Dates importantes pour les six prochains cycles :</p>
        <OvulationTableV2 result={result}></OvulationTableV2>
      </div>
    )
  }
}
function ConceptionTablev2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <tr>
            <th >État</th>
            <th >Résultats</th>
          </tr>
          <tr>
            <td >Dates de conception les plus probables</td>
            <td >{MonthConvert_year(response.mostProbableConceptionWindowStart)} au {MonthConvert_year(response.mostProbableConceptionWindowEnd)}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td >Dates de rapports sexuels les plus probables ayant conduit à la conception</td>
            <td >{MonthConvert_year(response.mostProbableDatesSexualIntercourseStart)} au {MonthConvert_year(response.mostProbabledatesSexualIntercourseEnd)}</td>
          </tr>
          <tr>
            <td >Dates de conception possibles</td>
            <td >{MonthConvert_year(response.possibleConceptionWindowStart)} au {MonthConvert_year(response.possibleConceptionWindowEnd)}</td>
          </tr>
          <tr>
            <td>
              Dates de rapports sexuels possibles ayant conduit à la conception :
            </td>
            <td>
              {MonthConvert_year(response.possibleDatesSexualIntercourseStart)} au {MonthConvert_year(response.possibleDatesSexualIntercourseEnd)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
export { PeriodTable, ConceptionTable, OvulationTable, OvulationTableV2, OvulationTableFull, ConceptionTablev2 };